export default __webpack_public_path__ + "static/media/cautare-dosare.c1382aac.png";